<template>
  <b-container style="padding: 2rem 0rem;">

  </b-container>
</template>

<script>
import ResizeText from 'vue-resize-text'
import { mapGetters } from 'vuex'
import appNameMixin from '../appNameMixin';

export default {
  name: 'login',
  mixins: [appNameMixin],
        data: () => ({
            login: {
                userId: '',
                password: '',
                remember: true
            },
        }),

      

  methods: {
       clearUser () {
      this.user.id1 = ''
      this.user.id2 = ''
      this.user.id3 = ''
      this.user.isLogin = true
      this.appMode = 0
    },
    loginSSO: function () {
      var vm = this
      this.$http.get('./auth/NewSSO')
        .then((response) => {
          var tmpData = response.data ;
          if (!tools.isNull(tmpData) ){
            vm.usrData = tmpData.usrData;
            vm.$store.dispatch('actionLogin', vm.usrData);
                      vm.clearUser();
                      this.$router.replace(
                                redirect && redirect !== '/' ? redirect : this.home);

          }else {
            tools.showAlert(vm, 'danger', '請檢查帳號密碼是否輸入正確');
            vm.clearUser();
          }
        })
        .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起, 登入失敗, 請檢查帳號密碼是否輸入正確' + error);
        })
    },

  },
  created () {
    console.log('======created Login =====')
    var userAgent = navigator.vendor
    if (userAgent.indexOf('Apple') > -1) {
      this.isIE = true
    } else {
      this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1
    }

    //todo
    this.loginSSO();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
